module.exports = __webpack_public_path__ + "media/components/slider/s3-b69d8f0a32a2b266c59cca4c3c93ea92.jpg";